import styled from '@emotion/styled'
import { TNLinkProps } from './TNLink'
import { tokens } from '@news-mono/design-tokens'

const { neutral, section } = tokens.thenightly.colors.palette

interface StyledTNLinkProps extends TNLinkProps {}

export const StyledTNLink = styled('a')<StyledTNLinkProps>(
    ({ color = section.opinion.default, display, fontWeight, disabled, marginBottom, width, underline = true }) => ({
        color: disabled ? neutral[50] : color,
        display,
        fontWeight,
        textUnderlinePosition: 'under',
        cursor: disabled ? 'no-drop' : 'pointer',
        textDecoration: underline ? 'underline' : 'none',
        marginBottom: marginBottom ?? undefined,
        width: width ?? undefined,
    }),
)
